var _excluded = ["api"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
export default function useUpdateRecordBase(mutationParams) {
  var useMutation = mutationParams.useMutation,
    mutationConfig = mutationParams.mutationConfig;
  return useMutation(function (_ref) {
    var model = _ref.model,
      id = _ref.id,
      data = _ref.data,
      params = _ref.params;
    var api = params.api,
      rest = _objectWithoutProperties(params, _excluded);
    return api.updateRecord(model, id, data, rest);
  }, mutationConfig);
}
//# sourceMappingURL=useUpdateRecordBase.js.map